import styled from 'styled-components';
import { TextButton } from 'elements/Input';
import { Link } from 'elements/Text';
import Box from 'elements/Box';

export const Navigation = styled(Box)(({ theme }) => `
  display: flex;
  margin-bottom: 1rem;
  grid-gap: 1rem;
`);
export const SubNavigation = styled(Navigation)`
  margin-bottom: 0;
`;
export const NavigationLink = styled(Link)(({ theme }) => `
  display: block;
`);
export const NavigationButton = styled(TextButton)``;
